import React from 'react'

import PropTypes from 'prop-types'

import AtomButton, {
  atomButtonColors,
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes
} from '@s-ui/react-atom-button'
import {ATOM_ICON_COLORS, ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import IconBellOutline from '@adv-mt/mt-svg-icons/lib/BellOutline.js'

const BUTTON_TYPES = {
  detail: 2,
  contactSeller: 3,
  assistant: 4
}

// eslint-disable-next-line react/prop-types
const DefaultCreateAlertButton = ({children, onClick, isFullWidth, size, isSearchModal, ariaLabel, disabled, icon}) => {
  return (
    <AtomButton
      color={atomButtonColors.ACCENT}
      fullWidth={isFullWidth}
      leftIcon={icon || <IconBellOutline aria-hidden size={ATOM_ICON_SIZES.medium} role="presentation" />}
      onClick={onClick}
      shape={atomButtonShapes.CIRCULAR}
      size={size}
      design={isSearchModal ? atomButtonDesigns.OUTLINE : atomButtonDesigns.SOLID}
      aria-label={ariaLabel}
      disabled={disabled}
    >
      {children}
    </AtomButton>
  )
}

function ButtonCreateAlert({children, isFullWidth, isSearchModal, onClick, size, type, ariaLabel, disabled, icon}) {
  if (type === BUTTON_TYPES.detail || type === BUTTON_TYPES.contactSeller) {
    return (
      <AtomButton
        design={atomButtonDesigns.OUTLINE}
        fullWidth
        leftIcon={
          icon || (
            <IconBellOutline
              aria-hidden
              color={ATOM_ICON_COLORS.currentColor}
              role="presentation"
              size={ATOM_ICON_SIZES.medium}
            />
          )
        }
        onClick={onClick}
        shape={atomButtonShapes.CIRCULAR}
        size={size}
        aria-label={ariaLabel}
        disabled={disabled}
      >
        {children}
      </AtomButton>
    )
  }

  if (type === BUTTON_TYPES.assistant) {
    return (
      <AtomButton
        design={atomButtonDesigns.FLAT}
        fullWidth={isFullWidth}
        leftIcon={
          icon || (
            <IconBellOutline
              aria-hidden
              color={ATOM_ICON_COLORS.currentColor}
              role="presentation"
              size={ATOM_ICON_SIZES.medium}
            />
          )
        }
        onClick={onClick}
        shape={atomButtonShapes.SQUARED}
        size={size}
        aria-label={ariaLabel}
        disabled={disabled}
      >
        {children}
      </AtomButton>
    )
  }

  return (
    <DefaultCreateAlertButton
      children={children}
      isFullWidth={isFullWidth}
      isSearchModal={isSearchModal}
      onClick={onClick}
      size={size}
      ariaLabel={ariaLabel}
      disabled={disabled}
    />
  )
}

ButtonCreateAlert.propTypes = {
  children: PropTypes.node.isRequired,
  isFullWidth: PropTypes.bool,
  isSearchModal: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(Object.values(atomButtonSizes)),
  type: PropTypes.oneOf(Object.values(BUTTON_TYPES)),
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.node
}

export default ButtonCreateAlert
export {BUTTON_TYPES as buttonTypes}
export {atomButtonSizes as buttonSizes}
